import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import {
  verifyDigitalKyc,
  fetchDigitalKycData,
} from "../../../Services/ApiTestService/apiTestService";
import { InputWithLabel, Button } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { DigiData } from "../Data";
import { Link, Navigate } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useService } from "../../../context/ServiceContext";
import { useSearchParams } from "react-router-dom";
import DigilockerKycCard from "../../../Components/Digilocker/KycData";
import { isNumeric } from "validator";

const DigitalKyc = () => {
  const [searchParams] = useSearchParams();
  const client_id = searchParams.get("client_id");
  const status = searchParams.get("status");
  const [isLoading, setIsLoading] = useState(false);
  const [kycData, setKycData] = useState({});
  const [errors, setErrors] = useState({});
  const [profileData, setProfileData] = useState({});
  const [showKycData, setShowKycData] = useState(false);
  const [redirectedURL, setRedirectedURL] = useState("");
  const [logoUrl, setLogoUrl] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [aadhaarNumber, setAadhaarNumber] = useState("");
  // const [mobile, setMobile] = useState("")

  const { serviceName } = useService();

  useEffect(() => {
    const fetchDetails = async () => {
      if (
        !profileData?.user_id ||
        !profileData?.api_key ||
        !profileData?.token_id
      )
        return;
      if (!client_id || status !== "success") return;

      try {
        setIsLoading(true);

        const resp = await fetchDigitalKycData({
          api_id: profileData.user_id,
          api_key: profileData.api_key,
          token_id: profileData.token_id,
          client_id,
        });

        const statusCode = resp?.status?.code || resp?.status;

        if (statusCode === 200) {
          setKycData(resp || {}); // here resp.data should be your KYC details
          setShowKycData(true);
          showSuccessToast("KYC details fetched successfully.");
        } else {
          showErrorToast(resp?.data?.message || "Failed to fetch KYC details");
        }
      } catch (e) {
        showErrorToast("Failed to fetch Digilocker Digital KYC details.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchDetails();
  }, [profileData, client_id, status]);

  // Fetch profile data on mount
  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        setIsLoading(true);
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error("Error fetching profile data:", error);
        showErrorToast("Failed to fetch profile data.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfileData();
  }, []);

  const validateForm = (redirectedURL, logoUrl) => {
    const errors = {};
    if (!redirectedURL) {
      errors.din = "Redirected URL is required.";
    }
    if (!logoUrl) {
      errors.din = "Logo URL is required.";
    }
    return errors;
  };

  const isNumber = (value) => {
    if (!value) return false;

    return isNumeric(value, { no_symbols: true });
  };
  // Digilocker uses OAuth-style redirect flow, and most OAuth providers (including Digilocker) block iframe embedding using X-Frame-Options header to prevent

  const handleSubmit = async () => {
    // const validationErrors = validateForm(redirectedURL, logoUrl);
    // setErrors(validationErrors);
    // if (Object.keys(validationErrors).length > 0) return;

    if (!mobileNumber && !aadhaarNumber)
      return showErrorToast("Please enter mobile number or aadhaar No.");

    const validateNumber = isNumber(mobileNumber);
    const validateAadhaar = isNumber(aadhaarNumber);

    if (!validateNumber && mobileNumber) {
      return showErrorToast("⚠️ Please enter number only in Mobile No. field");
    } else if (mobileNumber.length < 10 && mobileNumber) {
      return showErrorToast("⚠️ Enter at least 10 digits in Mobile No. field");
    }

    if (!validateAadhaar && aadhaarNumber) {
      return showErrorToast("⚠️ Please enter number only in Aadhaar No. field");
    } else if (aadhaarNumber.length < 12 && aadhaarNumber) {
      return showErrorToast("⚠️ Enter at least 12 digits in Aadhaar No. field");
    }

    try {
      setIsLoading(true);

      const payload = {
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        methodName: "generateToken",
        // redirectedURL: "http://localhost:3000/digilocker/digital-kyc",
        redirectedURL: "https://apiuser.idspay.in/digilocker/digital-kyc",
        logoUrl:
          "https://nidhibankingsoftware.in/public/storage/company-file/company.png",

        ...(mobileNumber && { mobile_number: mobileNumber }),
        ...(aadhaarNumber && { aadhaar_number: aadhaarNumber }),
      };

      const response = await verifyDigitalKyc(payload);

      const statusCode =
        response?.status?.code ||
        response?.status ||
        response?.data?.status?.code;

      if (response) {
        console.log(response);
      }

      if (statusCode === 200) {
        const resData = response?.data;

        if (resData) {
          setKycData(resData);
          setShowKycData(true);
          showSuccessToast(
            response.message,
            "Token and url Generated successfully.",
          );
          setRedirectedURL("");
          setLogoUrl("");
          setErrors({});

          if (resData?.url) {
            window.location.href = resData.url; // same tab
          }
        } else {
          showErrorToast("Unexpected API format.");
        }
      } else if (statusCode === 422) {
        showErrorToast(
          response?.data?.error?.error?.metadata?.fields[0]?.message ||
            response.data.message ||
            response?.message ||
            response?.data?.data?.message ||
            "Invalid format",
        );
      } else if (statusCode === 500) {
        showErrorToast(
          response?.data?.error?.error?.metadata?.fields[0]?.message ||
            response.data.message ||
            "Server error",
        );
      } else {
        showErrorToast(response.status?.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Digilocker Error:", error);
      showErrorToast("Failed to verify Digilocker Digital Kyc.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      <Header heading={serviceName} />

      <div className="w-full max-w-3xl mx-auto p-4 md:p-6">
        {/* Top Bar */}
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-semibold text-gray-900">
              DigiLocker Verification
            </h1>

            <p className="text-sm text-gray-500 mt-1">
              Verify using Mobile Number or Aadhaar Number
            </p>
          </div>

          <Link
            to="/TestMaster"
            className="inline-flex items-center gap-2 border border-gray-300 hover:border-gray-400 bg-white hover:bg-gray-50 px-4 py-2 rounded-lg text-sm font-medium text-gray-700 transition"
          >
            <IoArrowBackCircleOutline size={18} />
            Go Back
          </Link>
        </div>

        {/* Main Card */}
        <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-5 md:p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-8">
            {/* Mobile */}
            <div className="relative">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Mobile Number
              </label>

              <input
                type="tel"
                maxLength={10}
                value={mobileNumber}
                onChange={(e) => {
                  setMobileNumber(e.target.value);
                  setAadhaarNumber("");
                }}
                placeholder="Enter mobile number"
                className="w-full h-11 rounded-lg border border-gray-300 px-4 text-sm outline-none focus:border-black transition"
              />
              <span className="absolute hidden md:inline  bottom-2 -right-7 font-extrabold text-gray-600">
                OR
              </span>
            </div>

            <span className="w-full flex justify-center  md:hidden  font-extrabold text-gray-600">
              OR
            </span>

            {/* Aadhaar */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Aadhaar Number
              </label>

              <input
                type="tel"
                maxLength={12}
                value={aadhaarNumber}
                onChange={(e) => {
                  setAadhaarNumber(e.target.value);
                  setMobileNumber("");
                }}
                placeholder="Enter Aadhaar number"
                className="w-full h-11 rounded-lg border border-gray-300 px-4 text-sm outline-none focus:border-black transition"
              />
            </div>
          </div>

          {/* Divider */}
          <div className="flex items-center gap-3 my-5">
            <div className="flex-1 h-px bg-gray-200" />

            <span className="text-xs font-bold text-rose-600 uppercase tracking-wider">
              * Either one is required
            </span>

            <div className="flex-1 h-px bg-gray-200" />
          </div>

          {/* Submit */}
          <div className="flex justify-end">
            <button
              disabled={!mobileNumber && !aadhaarNumber}
              type="button"
              onClick={handleSubmit}
              className="h-10 px-6 rounded-lg bg-blue-700 disabled:opacity-50 hover:bg-gray-900 text-white text-sm font-medium transition"
            >
              Verify
            </button>
          </div>
        </div>
      </div>
      <DigilockerKycCard data={kycData?.data} fulldata={kycData}/>
    </>
  );
};

export default DigitalKyc;
